import { ArrowUpRight } from "lucide-react";
import { BUY_URL, CHART_URL, X_URL } from "@/config/actra";

export const BuyButton = ({ compact = false }) => (
    <a
        href={BUY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="buy-actra-button"
        className={`inline-flex items-center gap-2 whitespace-nowrap border border-[#1677FF]/50 bg-[#1677FF]/10 font-mono font-semibold uppercase tracking-[0.2em] text-[#8CB8FF] transition-all duration-300 hover:bg-[#1677FF] hover:text-white ${
            compact ? "px-3.5 py-2 text-[10px]" : "px-6 py-3.5 text-[11px]"
        }`}
    >
        BUY $ACTRA <ArrowUpRight size={compact ? 12 : 14} />
    </a>
);

export const ChartButton = ({ compact = false }) => (
    <a
        href={CHART_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="view-chart-button"
        className={`inline-flex items-center gap-2 whitespace-nowrap border border-white/15 font-mono font-semibold uppercase tracking-[0.2em] text-ink transition-all duration-300 hover:border-[#31D8FF] hover:text-[#31D8FF] ${
            compact ? "px-3.5 py-2 text-[10px]" : "px-6 py-3.5 text-[11px]"
        }`}
    >
        VIEW CHART <ArrowUpRight size={compact ? 12 : 14} />
    </a>
);

export const XIconButton = () => (
    <a
        href={X_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="x-social-link"
        aria-label="ACTRA on X"
        className="flex h-9 w-9 items-center justify-center border border-white/15 font-display text-sm font-bold text-ink transition-all duration-300 hover:border-[#1677FF] hover:bg-[#1677FF]/10"
    >
        X
    </a>
);

export const XTextLink = ({ children, className = "", testid = "x-text-link" }) => (
    <a
        href={X_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={`inline-flex items-center gap-3 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-ink transition-all duration-300 hover:text-[#31D8FF] ${className}`}
    >
        {children} <ArrowUpRight size={14} />
    </a>
);
